var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Publishers","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a publisher's name...","toggle":true,"field":"publisher_name","filter":_vm.value('publishers'),"api":"publishers/suggest","data":"publishers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }